import { ConstAnnotationTypeId } from '../Constant'

export const ConstAnnotationType = {
    UserDetails:'User details',
    UserGroup:'User group',
    DateAndTime:'Date & Time',
    Permissions:'Permissions',
    Other:'Other',
  }

export const getExtractedData = (data: any,annotateType:string) => {
    if (!data) return []
    if(annotateType === ConstAnnotationType.UserDetails) {
        return data.userDetails ? data.userDetails : []
    }
    else if(annotateType === ConstAnnotationType.UserGroup){
        return data.userGroup ? data.userGroup : []
    }
    else if(annotateType === ConstAnnotationType.DateAndTime){
        return data.date ? data.date : []
    }
    else if(annotateType === ConstAnnotationType.Permissions){
        return data && (data.permissions || data.permission) ? (data.permissions || data.permission) : []
    }
    else if(annotateType === ConstAnnotationType.Other){
        return data.other ? data.other : []
    }
}

// True when the given annotation type GUID is either evidence context's
// "Other" type (Dev or Impl). Used to gate the custom other-type-name input —
// must check both variants, not just one, otherwise the input never renders
// for the other evidence context and its custom name can't be entered/edited.
export const isOtherAnnotationTypeId = (annotationTypeId?: string | null): boolean => {
  if (!annotationTypeId) return false
  const id = annotationTypeId.toUpperCase()
  return id === ConstAnnotationTypeId.DevOther.toUpperCase() || id === ConstAnnotationTypeId.ImplOther.toUpperCase()
}

// Maps an annotation type's GUID to the record-array key used inside its
// evaluated-value JSON blob (e.g. { userDetails: [...] }).
export const getRecordArrayKey = (annotationTypeId: string): string | null => {
  const id = annotationTypeId?.toUpperCase()
  if (id === ConstAnnotationTypeId.DevUserDetails.toUpperCase() || id === ConstAnnotationTypeId.ImplUserDetails.toUpperCase()) {
    return 'userDetails'
  }
  if (id === ConstAnnotationTypeId.DevUserGroup.toUpperCase() || id === ConstAnnotationTypeId.ImplUserGroup.toUpperCase()) {
    return 'userGroup'
  }
  if (id === ConstAnnotationTypeId.DevPermissions.toUpperCase() || id === ConstAnnotationTypeId.ImplPermissions.toUpperCase()) {
    // BE serializes LLMPermissionListJSONDTO.Permission (singular) as camelCase "permission".
    return 'permission'
  }
  if (id === ConstAnnotationTypeId.DevOther.toUpperCase() || id === ConstAnnotationTypeId.ImplOther.toUpperCase()) {
    return 'other'
  }
  if (id === ConstAnnotationTypeId.DevDateAndTime.toUpperCase() || id === ConstAnnotationTypeId.ImplDateAndTime.toUpperCase()) {
    return 'dateAndTime'
  }
  return null
}

// Flattens raw evaluated-value JSON chunks (strings or already-parsed objects)
// into a single flat array of row records for the given annotation type.
export const flattenChunksToRows = (chunks: any[], annotationTypeId: string): any[] => {
  const recordArrayKey = getRecordArrayKey(annotationTypeId)
  if (!recordArrayKey) return []
  return chunks.flatMap((chunk: any) => {
    try {
      const parsed = typeof chunk === 'string' ? JSON.parse(chunk) : chunk
      return Array.isArray(parsed?.[recordArrayKey]) ? parsed[recordArrayKey] : []
    } catch {
      return []
    }
  })
}